import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import i18n from 'i18next';

import { useQuery, useApolloClient } from '@apollo/client';

import { GET_INFOUSER } from '@betwixt/common/graphql/user.js';

import Loading from '@betwixt/common/components/Loading.js';

import SignupComponent from '../../views/Signup.js';
import LoginComponent from '../../views/Login.js';
import NoMatchComponent from '../../views/NoMatch.js';
import CreateComponent from './CreateComponent.js';
import PrivateRoute from './PrivateRoute.js';

const ManageRoutes = (props) => {
  const { gConfig } = props;

  const client = useApolloClient();
  const { loading, data } = useQuery(GET_INFOUSER);

  const User = (data && data.User) || false;

  if (loading) return <Loading type="ring" />;

  return (
    <Switch>
      <Route exact path="/login" component={() => <LoginComponent gConfig={gConfig} />} />
      <Route path="/signup" component={() => <SignupComponent gConfig={gConfig} />} />
      {data && User && User.modulesActived
        ? createPrivateItemsRoute('SECONDARY_ROUTES', User, client, gConfig)
        : ''}
      {data && User && User.modulesActived
        ? createPrivateItemsRoute('ROUTES', User, client, gConfig)
        : ''}
      <Route path="/error" component={() => <NoMatchComponent gConfig={gConfig} />} />
      <Route component={() => <NoMatchComponent User={User} gConfig={gConfig} />} />
    </Switch>
  );
};

export default ManageRoutes;

ManageRoutes.propTypes = {
  gConfig: PropTypes.object.isRequired,
};

const createPrivateItemsRoute = (type, User, client, gConfig) => {
  return User.modulesActived.map((item, index) => {
    if (type === 'ROUTES') {
      return createPrivateRoute(
        type,
        index,
        item,
        item,
        User,
        client,
        gConfig,
      );
    } else if (type === 'SECONDARY_ROUTES') {
      if (item.routes.my && item.routes.my.secondary !== null && item.routes.my.secondary.length) {
        return item.routes.my.secondary.map((secondary_item, secondary_index) => {
          return createPrivateRoute(
            type,
            secondary_index,
            secondary_item,
            item,
            User,
            client,
            gConfig,
          );
        });
      }
    }
    return false;
  });
};

const createPrivateRoute = (
  type,
  index,
  item,
  firstItem,
  User,
  client,
  gConfig,
) => {
  try {
    const moduleConfig = firstItem ? firstItem : item;
    const moduleId = item.module ? item.module.id : firstItem.module.id;
    const componentId = item.component.id;
    const routerPath = firstItem ? firstItem.routes.my.path : item.routes.my.path;
    const moduleUrl = routerPath;
    const endPoint = item.routes
      ? item.routes.path
        ? item.routes.path
        : componentId
      : componentId;

    let endpointComponent;
    let privateRoutePath;

    if (type === 'SECONDARY_ROUTES') {
      endpointComponent = `${routerPath}/my/${componentId}`;
      privateRoutePath = `/${routerPath}/${endPoint}`;
    } else if (type === 'ROUTES') {
      endpointComponent = `${routerPath}/my/${componentId}`;
      privateRoutePath = `/${routerPath}`;
    }

    // console.log("[router][createRoute]: ", " | ", moduleId, " | ", componentId, " | ", moduleConfig, " | ", routerPath, " | ", endpointComponent, " | ", privateRoutePath, " | ", moduleUrl)

    const cComponent = (props) => (
      <CreateComponent
        {...props}
        endpointComponent={endpointComponent}
        pagename={moduleId}
        moduleId={moduleId}
        moduleConfig={moduleConfig}
        moduleUrl={moduleUrl}
        User={User}
        client={client}
        i18n={i18n}
        t={i18n.getFixedT(null, moduleId)}
        gConfig={gConfig}
      >
        {(Component) =>
          Component === null ? <Loading type="ring" /> : <Component {...this.props} />
        }
      </CreateComponent>
    );

    return (
      <PrivateRoute
        key={index.toString()}
        path={privateRoutePath}
        component={cComponent}
        User={User}
        i18n={i18n}
      />
    );
  } catch (err) {
    console.error(err);
  }
};
